import React, { Component } from "react";
import "./StepProgress.css";
import PropTypes from "prop-types";
import Link from "./Link";

export default class StepProgress extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selected: props.current
        }
    }

    render() {
        const { current, resource, steps, disableProgress, max, horizontal } = this.props;
        return (
            <div className={horizontal ? "StepProgress-base-horizontal" : "StepProgress-base"}>
                <div className={horizontal ? "StepProgress-horizontal" : "StepProgress"}>
                    {steps.map((v, i) => {
                        const disabled = (i > max) || (i > current && disableProgress);
                        return (
                            <Link
                                disabled={disabled}
                                key={i}
                                bare
                                to={String(resource + String(i))}
                                styleName={horizontal ? "StepProgress-link-horizontal" : ""}
                            >
                                <div className={
                                    (horizontal ? "StepProgress-item-horizontal" : "StepProgress-item") +
                                    (i === current ? (horizontal ? " StepProgress-current-horizontal" : " StepProgress-current") : "") +
                                    (disabled ? " StepProgress-disabled" : "")
                                }>
                                    {v}
                                </div>
                            </Link>
                        );
                    })}
                </div>
            </div>
        );
    }

}

StepProgress.propTypes = {
    steps: PropTypes.arrayOf(PropTypes.node).isRequired,
    current: PropTypes.number,
    handleClick: PropTypes.func,
    max: PropTypes.number,
    resource: PropTypes.string.isRequired,
    disableProgress: PropTypes.bool
}